import styled from 'styled-components';

const MONTH_NAMES = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

export function formatDatePill(isoDate: string): string {
	const [year, month, day] = isoDate.split('-').map(Number);
	if (!year || !month || !day) return isoDate;
	const monthName = MONTH_NAMES[month - 1] ?? '';
	return `${day} ${monthName} ${year}`;
}

const Pill = styled.span`
	display: inline-flex;
	align-items: center;
	padding: 0 ${p => p.theme.sys.spacing[200]};
	height: 32px;
	border-radius: ${p => p.theme.sys.size.borderradius['3']};
	border: ${p => p.theme.sys.size.borderwidth.thin} solid ${p => p.theme.sys.color.border.decorative};
	background: ${p => p.theme.sys.color.background.neutral['1']};
	${p => p.theme.sys.font?.body?.['2']}
	color: ${p => p.theme.sys.color.text.content.main};
	white-space: nowrap;
	cursor: default;
`;

interface Props {
	isoDate: string;
	'data-testid'?: string;
}

export function DatePill({isoDate, ...rest}: Props) {
	return <Pill data-testid={rest['data-testid']}>{formatDatePill(isoDate)}</Pill>;
}
